import { render, staticRenderFns } from "./DataEntryNewMainView.vue?vue&type=template&id=6d5dd586&scoped=true"
import script from "./DataEntryNewMainView.vue?vue&type=script&lang=js"
export * from "./DataEntryNewMainView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5dd586",
  null
  
)

export default component.exports